import EventProcessor from "../../event/EventProcessor"
import UserEventFactory from "../../event/UserEventFactory"
import { EvaluatorRequest } from "./Evaluator"
import { EvaluatorEvaluation } from "./Evaluator"

export class EvaluationEventRecorder {
  constructor(private readonly eventFactory: UserEventFactory, private readonly eventProcessor: EventProcessor) {}

  record(request: EvaluatorRequest, evaluation: EvaluatorEvaluation): void {
    const events = this.eventFactory.create(request, evaluation)
    events.forEach((event) => {
      this.eventProcessor.process(event)
    })
  }
}
